import ImageCheckbox, {ImageCheckboxProps} from "./ImageCheckbox";
import "./HorizontalScrollImageCheckbox.module.scss";
import React from "react";

const HorizontalScrollImageCheckbox = ({imageCheckboxes}: {imageCheckboxes: ImageCheckboxProps[]} ) => {
  return <div style={{width: "100%", overflow: "auto"}}>
        <div style={{display: "flex"}}>
            {imageCheckboxes.map((imageCheckboxProp, i) => {
                return <span key={i} style={{width: "90px", flexShrink:0, margin: "8px"}}>
                 <ImageCheckbox {...imageCheckboxProp}/>
                </span>
            })}
        </div>
    </div>
}

export default HorizontalScrollImageCheckbox;